// Module
var code = " <h2> Project 1 documentation </h2> <p>Submit:</p> <ul> <li>A link to your documentation and design sketches.</li> <li>These should be presented on your publicly accessible portfolio page. </li> </ul> <p>The description for the documentation requirements are available at the project 1 page. Project 1- Interface to a smart object</p>";
// Exports
export default code;